import router from '@/router'
import store from '@/store'
import { login } from '@/services/auth/login'
import { changePasswordFirstLogin } from '@/services/auth/changePasswordFirstLogin'
import { checkOTPCode } from '@/services/auth/checkOTPCode'
import { me } from '@/services/auth/me'
import { recoveryPassword } from '@/services/auth/recoveryPassword'
import { getMisModulos } from '@/services/auth/getMisModulos'
import { getPermisos } from '@/services/auth/getPermisos'
import { i18n, getLocale, getClosestLocale } from '@/i18n'
// import { logout } from '@/services/auth/logout'

// import _ from 'lodash'

const state = () => ({
  user: null,
  role: null,
  locale: getLocale(),
  auth: {
    loggedIn: false,
    accessToken: null,
    refreshToken: null
  },
  modules: [],
  permisos: [],
})

const getters = {
  httpQueryHeaders: state => {
    const headers = {
      'Content-type': 'application/json',
      'access-control-allow-origin': '*'
    }
    /*
    if (state.currentCompany !== '') {
      headers['X-Fidery-Company'] = state.currentCompany
    }
    if (state.currentBusiness !== '') {
      headers['X-Fidery-Business'] = state.currentBusiness
    }
    */
    return headers
  },
  user: state => state.user,
  modules: state => state.modules,
  permisos: state => state.permisos,
  hasPermissionEditVisiblity: state => {
    return state.permisos?.PermitirEdicionPermisos
  },
  hasReceivedInvoiceModule: state => {
    return state.modules.some(x => x.idModulo === -2) || true
  },
  hasSendInvoiceModule: state => {
    return state.modules.some(x => x.idModulo === -1) || true
  },
  hasOCRIntegrationModule: state => {
    return state.modules.some(x => x.idModulo === 1)
  },
  hasERPIntegrationModule: state => {
    return state.modules.some(x => x.idModulo === 2)
  },
  hasAutofacturaModule: state => {
    return state.modules.some(x => x.idModulo === 3)
  },
  hasReceivedWebHooksModule: state => {
    return state.modules.some(x => x.idModulo === 4)
  },
  hasIssuedWebHooksModule: state => {
    return state.modules.some(x => x.idModulo === 5)
  },
  hasAnyWebHooksModule: (state, getters) => {
    return getters.hasReceivedWebHooksModule || getters.hasIssuedWebHooksModule
  },
  hasAprobationFlowModule: state => {
    return state.modules.some(x => x.idModulo === 6)
  },
  hasXsltModule: state => {
    return state.modules.some(x => x.idModulo === 7)
  },
  hasTBAIModule: state => {
    return state.modules.some(x => x.idModulo === 8)
  },

  hasModuleIntegracionAAD: state => {
    return state.modules.some(x => x.idModulo === 9)
  },

  hasModuleInterfazEmision: state => {
    return state.modules.some(x => x.idModulo === 10)
  },

  hasModuleAgrupaciones: state => {
    return state.modules.some(x => x.idModulo === 15)
  },
  
  hasModuleCustomSMTPZerocoma: state => {
    return state.modules.some(x => x.idModulo === 16)
  },
  hasModuleCustomSMTPCliente: state => {
    return state.modules.some(x => x.idModulo === 17)
  },
  hasModuleCustomMails: state => {
    return state.modules.some(x => x.idModulo === 18)
  },
  hasModuleCustomLogo: state => {
    return state.modules.some(x => x.idModulo === 19)
  },
  hasModuleCustomColors: state => {
    return state.modules.some(x => x.idModulo === 22)
  },

  hasModuleSAML2: state => {
    return state.modules.some(x => x.idModulo === 30)
  },

  hasVerifactuModule: state => {
    return state.modules.some(x => x.idModulo === 31)
  },

  idTipoProvisionamientoDistribuidor: state => state.user?.idTipoProvisionamiento,
  userId: state => state.user?.idUsuario,
  loggedIn: state => !!((state.auth.loggedIn && state.auth.accessToken)),
  accessToken: state => state.auth.accessToken,
  refreshToken: state => state.auth.refreshToken,
  temporalToken: state => state.auth.temporalToken,
  role: state => (state.role || state.user?.idRol),
  idTipoServicioCliente: state => (state.user?.idTipoServicioCliente),
  locale: state => state.user?.LangCode ?? state.locale,
  lang: (state, getters) => (langs = []) => {
    // let lang = getters.locale
    // if (!langs.includes(lang)) {
    //   lang = lang.split('-').shift()
    //   /*
    //   if (!langs.includes(lang)) {
    //     lang = i18n.fallbackLocale
    //   }
    //   */
    // }

    // return lang
    return getClosestLocale(getters.lang, { availableLocales: langs })
  },
}

const mutations = {
  setRole (state, role) {
    state.role = role
  },
  setUser (state, user) {
    state.user = user
    state.auth.loggedIn = true
    this.commit('auth/setLocale', user?.LangCode || getLocale())
  },
  setModules (state, modules) {
    state.modules = modules
  },
  removeUser (state) {
    state.user = null
    state.modules = []
    state.auth.loggedIn = false
    this.commit('auth/setLocale', getLocale())
  },
  setTokens (state, { accessToken, refreshToken, temporalToken }) {
    state.auth.accessToken = accessToken
    state.auth.refreshToken = refreshToken
    state.auth.temporalToken = temporalToken
  },
  setLocale (state, locale) {
    locale = getClosestLocale(locale)
    if (state.user) {
      state.user.LangCode = locale
    }
    i18n.locale = locale
    store.dispatch('config/cleanConfigCache')
  },
  removeTokens (state) {
    state.auth.accessToken = null
    state.auth.refreshToken = null
    state.auth.temporalToken = null
  },
  get_modules_success (state, modules) {
    state.modules = modules
  },
  get_permisos_success (state, permisos) {
    state.permisos = permisos
  },
}

async function commonLogin (commit, data) {
  commit('setTokens', {
    accessToken: data.AccessToken,
    refreshToken: data.RefreshToken,
    temporalToken: data.TemporalToken,
  })
  if (data.TemporalToken) {
    // Creamos error y gestiona Login
    const errorPwdCad = { 
      blnError: true,
      msgError: '',
      codError: 'COD' + data.StepCode,
      stepCode: data.StepCode,
    }
    if (data.StepCode === 1) {
      // Contraseña expirada (necesario cambio contraseña)
      errorPwdCad.msgError = i18n.t('feedback.error.expired_password_error')
    }
    throw errorPwdCad
  } else {
    // Login sin pasos previos (AuthWeb)
    const user = await me()
    if (user.blnError === true) {
      throw user
    } else {
      commit('setUser', user.respuesta)
      // TASK POST LOGIN
      store.dispatch('app/updateidClienteFilterNav', null)
      store.dispatch('app/updateidClienteFilterUpload', null)
      store.dispatch('app/updateidClienteFilterAlerts', null)
      if (user.respuesta.idRol === 3) {
        // Reset Dashboard filter
        if (store.getters['dashboard/getUnableDashboard']) {
          store.dispatch('dashboard/setSelectedClient', -1)
        }
      }
      await store.dispatch('app/getColors')
      store.dispatch('app/updateFrontColors')
    }
    router.push({ name: process.env.VUE_APP_REDIRECT_LOGGED_IN })
  }
}

const actions = {
  async loginTokens ({ commit }, { AccessToken, RefreshToken }) {
    await commonLogin(commit, {
      AccessToken,
      RefreshToken,
    })
  },
  async login ({ commit }, { email, password }) {
    const data = await login(email, password)
    if (data.blnError === true) {
      throw data
    } else {
      await commonLogin(commit, data)
    }
  },
  async firstLoginPassword ({ commit }, { oldPassword, password }) {
    const data = await changePasswordFirstLogin(password, oldPassword)
    if (data.blnError === true) {
      throw data
    } else {
      await commonLogin(commit, data)
    }
  },
  async checkOTPLogin ({ commit }, { otpCode }) {
    const data = await checkOTPCode(otpCode)
    if (data.blnError === true) {
      throw data
    } else {
      await commonLogin(commit, data)
    }
  },
  async logout ({ commit }) {
    commit('removeUser')
    commit('removeTokens')
    store.dispatch('app/updatecontrolFlagLicense', false)

    // Reset all stores
    store.dispatch('invoicesIssued/resetCartState')
    store.dispatch('invoicesReceived/resetCartState')
    store.dispatch('historicalUser/resetCartState')
    store.dispatch('historicalClient/resetCartState')
    store.dispatch('historicalCert/resetCartState')
    store.dispatch('historicalCompany/resetCartState')
    store.dispatch('historicalInvoice/resetCartState')
    store.dispatch('companies/resetCartState')

    store.dispatch('certificates/resetCartState')
    store.dispatch('certcompanies/resetCartState')
    store.dispatch('clients/resetCartState')
    store.dispatch('users/resetCartState')
    store.dispatch('userscompanies/resetCartState')
    store.dispatch('userstatus/resetCartState')

    store.dispatch('groups/resetCartState')
    store.dispatch('groupusers/resetCartState')
    store.dispatch('groupcompanies/resetCartState')
    store.dispatch('groupstatus/resetCartState')
    store.dispatch('invoicegroups/resetCartState')
    store.dispatch('usergroups/resetCartState')

    // Distribuidor
    store.dispatch('distributors/resetCartState')
    store.dispatch('historicalDistributor/resetCartState')

    // Agrupaciones
    store.dispatch('groupingcompanies/resetCartState')
    store.dispatch('groupingbuyers/resetCartState')
    store.dispatch('groupingsellers/resetCartState')

    // Sociedades
    store.dispatch('sociedades/resetCartState')
    store.dispatch('trashSociedades/resetCartState')
    store.dispatch('historicalContact/resetCartState')
    store.dispatch('trashHistoricalContacts/resetCartState')
    store.dispatch('sedes/resetCartState')
    store.dispatch('administrativecenters/resetCartState')
    store.dispatch('administrativecentersfb2b/resetCartState')

    store.dispatch('impuestos/resetCartState')
    store.dispatch('trashImpuestos/resetCartState')
    store.dispatch('historicalImpuestos/resetCartState')
    store.dispatch('trashHistoricalImpuestos/resetCartState')

    store.dispatch('products/resetCartState')
    store.dispatch('productsImpuestos/resetCartState')
    store.dispatch('trashProducts/resetCartState')
    store.dispatch('historicalProducts/resetCartState')
    store.dispatch('trashHistoricalProducts/resetCartState')

    // Papelera
    store.dispatch('trashUsers/resetCartState')
    store.dispatch('trashHistoricalUsers/resetCartState')
    store.dispatch('trashInvoicesIssued/resetCartState')
    store.dispatch('trashHistoricalInvoices/resetCartState')
    store.dispatch('trashCertificates/resetCartState')
    store.dispatch('trashHistoricalCertificates/resetCartState')
    store.dispatch('trashCompanies/resetCartState')
    store.dispatch('trashHistoricalCompanies/resetCartState')
    store.dispatch('trashGroups/resetCartState')
    store.dispatch('trashHistoricalGroups/resetCartState')

    // Actualmente sin uso
    store.dispatch('trashClients/resetCartState')
    store.dispatch('trashHistoricalClients/resetCartState')

    // Reset Dashboard filter
    store.dispatch('dashboard/setSelectedClient', -1)
    store.dispatch('dashboard/setSelectedClientName', null)

    // Reset filter general
    store.dispatch('app/updateidClienteFilterNav', null)
    store.dispatch('app/updateidClienteFilterAlerts', null)
    store.dispatch('app/updateidClienteFilterUpload', null)

    router.push({ name: process.env.VUE_APP_REDIRECT_FAILED_AUTHENTICATION })
  },
  getModules ({ commit }) {
    return new Promise((resolve, reject) => {
      getMisModulos().then(response => {
        if (response.blnError) {
          return Promise.reject(response)
        }
        commit('get_modules_success', response.Modulos)
        resolve(response)
      })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPermisos ({ commit }) {
    return new Promise((resolve, reject) => {
      getPermisos().then(response => {
        if (response.blnError) {
          return Promise.reject(response)
        }
        commit('get_permisos_success', response.respuesta)
        resolve(response)
      })
        .catch(err => {
          reject(err)
        })
    })
  },
  async recoveryPassword ({ commit }, { email }) {
    const data = await recoveryPassword(email)
    if (data.blnError === true) {
      throw data
    } else {
      commit('setTokens', {
        accessToken: data.Token,
        refreshToken: data.RefreshToken
      })
      commit('setUser', null)
      router.push({ name: process.env.VUE_APP_REDIRECT_LOGGED_IN })
    }
  },
  async me ({ commit }, { navigate = false }) {
    const data = await me()
    if (data.blnError === true) {
      throw data
    } else {
      commit('setUser', data.respuesta)
      if (navigate) {
        const IdUsuario = data.respuesta.IdUsuario
        router.push({ name: 'configurations/users/profile', params: { id: IdUsuario } })
      }
    }
  },
  reloadLocale ({ commit, getters }) {
    const langCode = getters.user?.LangCode
    if (langCode && langCode !== i18n.locale) {
      commit('setLocale', langCode)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
